import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-title-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './title-page.component.html',
  styleUrls: ['./title-page.component.scss'],
})
export class TitlePageComponent {
  title = input.required<string>();
  subtitle = input<string>('');
}
